// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"2df20f41","181":"4b0c31d2","185":"89bd82bc","277":"569e7a4b","517":"96318f1a","544":"2e1c987c","634":"79b807fa","667":"fc389206"}[chunkId] + ".chunk.js";
};